import { jsx as _jsx } from "react/jsx-runtime";
import { SurveyCreatorComponent } from "survey-creator-react";
import FormConfigurationStep from "../FormConfigurationStep";
var FormStepsContent = function (_a) {
    var step = _a.step, creator = _a.creator, preFormInfo = _a.preFormInfo, setPreFormInfo = _a.setPreFormInfo, autoSyncSlugFromTitle = _a.autoSyncSlugFromTitle, formTitleInputRef = _a.formTitleInputRef, formSlugInputRef = _a.formSlugInputRef, urlPrefix = _a.urlPrefix;
    switch (step) {
        case 0:
            return (_jsx(SurveyCreatorComponent, { creator: creator, style: { minHeight: "850px" } }));
        case 1:
            return (_jsx(FormConfigurationStep, { preFormInfo: preFormInfo, creator: creator, autoSyncSlugFromTitle: autoSyncSlugFromTitle, formTitleInputRef: formTitleInputRef, formSlugInputRef: formSlugInputRef, urlPrefix: urlPrefix, setPreFormInfo: setPreFormInfo }));
        default:
            return null;
    }
};
export default FormStepsContent;
